import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "radio-button-group" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = { class: "p-field-radiobutton" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectOptions, (selectOption) => {
      return (_openBlock(), _createBlock(_Fragment, { key: selectOption }, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_RadioButton, {
            id: _ctx.idPrefix + '_' + selectOption.value,
            value: selectOption.value,
            modelValue: _ctx.selectValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectValue = $event))
          }, null, 8, ["id", "value", "modelValue"]),
          _createVNode("label", {
            for: _ctx.idPrefix + '_' + selectOption.value
          }, _toDisplayString(selectOption.label), 9, ["for"])
        ]),
        _hoisted_4
      ], 64))
    }), 128))
  ]))
}